import { isDevMode } from "@/utils";

export default {
    isInitialised(state) { return state.isInitialised.session && state.isInitialised.metadata; },
    isMetadataInitialised(state) { return state.isInitialised.metadata; },
    error(state) { return state.error; },
    showError(state) { return state.error.show; },
    urlPath(state, getters) { return getters.isInitialised ? state.urlPath : ''; },
    isDesktop(state) { return state.windowInnerWidth >= 992; },
    isLocalhost() { return window.location.href.indexOf("localhost") >= 0; },
    sessionStep(state) {
        if(state.session.data.is_completed) { return "FINISHED"; }
        if(state.session.data.has_done_about_you) { return "CHECKOUT"; }
        if(state.session.data.has_booked_npc) { return "ABOUT_YOU"; }
        if(state.userRequestsAvailability) { return "AVAILABILITY"; }
        
        return "FILTERS";
    },
    userRequestsAvailability(state) { return state.userRequestsAvailability; },
    
    session(state) { return state.session.data; },
    isLoadingSession(state) { return state.session.isLoading; },
    isSessionInitialised(state) { return state.isInitialised.session ? true : false; },
    hasSession(state) { return !state.session.isLoading && state.session.data; },
    queryStringParams(state) { return state.queryStringParams; },
    queryStringParam(state) {
        return key => Object.keys(state.queryStringParams).some(k => k === key) ? state.queryStringParams[key] : "";
    },
    queryStringSessionId(state) { return state.queryStringParams.sessionid || ''; },
    serverTimeDiffSeconds(state) { return state.serverTimeDiffSeconds; },

    isLoadingClinics(state) { return state.clinics.isLoading; },
    hasClinics(state) { return !state.clinics.isLoading && (state.clinics.data.length >= 1); },
    clinics(state) { return state.clinics.data; },
    clinicById(state) {
        return id => {
            return state.clinics.data.find(clinic => clinic.id == id);
        };
    },
    dropdownLocations(state) { return state.clinics.dropdownLocations; },

    isLoadingDCs(state) { return state.dcs.isLoading; },
    hasDCs(state) { return !state.dcs.isLoading && (state.dcs.data.length >= 1); },
    dcs(state) { return state.dcs.data; },
    dcById(state) {
        return id => {
            return state.dcs.data.find(dc => dc.id == id);
        };
    },

    dropdownDCs(state) { return state.dcs.dropdownDCs; },
    typeaheadDCs(state) { return state.dcs.typeaheadDCs; },
    dropdownReferralSources(state) { return state.dropdownReferralSources; },

    dcGenders(state) { return state.settings.dc_genders || []; },
    pregnantCategs(state) { return state.settings.pregnant_categs || []; },
    ageCategs(state) { return state.settings.age_categs || []; },
    yesNoCategs(state) { return state.settings.yes_no || []; },

    customUrlCode(state) { return state.session?.data?.custom_url_code ?? false; },

    skipToLocationId(state) {
        if (!state.session.data || !state.session.data.custom_url_json) return 0;
        return state.session.data.custom_url_json.skip_to_location_id || 0;
    },
    shouldSkipLocationSelection(_state, getters) { return getters.skipToLocationId || false; },

    //  Availability slots, when booking NPC / RoF appointments
    //  NPC/ROF slots are same state variable because... different screens will use different instances of app so there shouldn't be a clash
    slots(state) { return state.slots.data; },
    isLoadingSlots(state) { return state.slots.isLoading; },
    slotsDCUsedByAPI(state) { return state.slots.dc; },
    slotsAPISaysThereAreOtherDCs(state) { return state.slots.thereAreOtherDCs; },

    appointments(state) { return state.appointments.data; },
    isLoadingAppointments(state) { return state.appointments.isLoading; },

    availabilityParams(state) { return state.availability.params; },
    availabilityResults(state) { return state.availability.results; },
    availabilityOutcomes(state) { return state.availability.outcomes; },

    isLoadingSessionOrMetadata(state) { return state.session.isLoading || state.clinics.isLoading || state.dcs.isLoading; },

    showAboutYou(state) { return state.isInitialised.session && state.isInitialised.metadata; },

    dobDays(state) { return state.dobDays; },
    dobMonths(state) { return state.dobMonths; },
    dobYears(state) { return state.dobYears; },
    stripeData(state) {
        return state.stripe;
    },
    isPaymentGatewayLive(state) {
        return state.settings.is_gateway_live  && !isDevMode ? true : false;
    },
    stripePublishableKey(state, getters) {
        return getters.isPaymentGatewayLive ? state.stripe.publishableKeyLive : state.stripe.publishableKeyTest;
    },
    stripeProduct(state) {
        const productId = state.session.data?.stripe_product_id ?? state.settings.default_stripe_product_id;
        return state.stripeProducts.data.find(p => p.id === productId);
    },
    stripeRequiresPayment(state) {
        const productId = state.session.data?.stripe_product_id ?? state.settings.default_stripe_product_id;
        const product = state.stripeProducts.data.find(p => p.id === productId);
        return product.price >= 0.01;
    },
    numberOfPages(state) { return state.numberOfPages; },
    pageNumber(state) { return (page) => {
        console.log(`get.pageNumer`, page, state.pageNumbers);
        
        return state.pageNumbers && state.pageNumbers[page] ? state.pageNumbers[page] : 1; };
    },
};
